import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navContainer"];

  connect() {
    this.checkDisplayOnResize();
    window.addEventListener('resize', () => this.checkDisplayOnResize());
  }

  disconnect() {
    window.removeEventListener('resize', () => this.checkDisplayOnResize());
  }

  toggleMenu() {
    const navContainer = this.navContainerTarget;
    navContainer.style.display = navContainer.style.display === 'block' ? 'none' : 'block';
  }

  checkDisplayOnResize() {
    if (window.innerWidth > 1024) {
      this.navContainerTarget.style.display = 'flex';
    } else {
      this.navContainerTarget.style.display = 'none';
    }
  }
}
